import React from 'react';
import {DropdownButton, MenuItem} from 'react-bootstrap';
import i18next from 'i18next';

export const DcoDropdown = (props) => {
return (
  <div className={props.parentDivClassname} id={props.parentDivId}>
  <DropdownButton title={props.dropdownTitle}  id={props.dropdownId} className={props.dropdownClassname} style={props.dropdownStyle}>
  {
        props.dropdownData.map((item) => {
        return (
          <MenuItem className={props.menuClassname} style={props.menuStyle}
          onClick={() => props.dataItemClick(item.cmdtId,item.cmdtDesc)}
          >
            {i18next.t(item.cmdtDesc)}
          </MenuItem>
        );
      })
    }
  </DropdownButton>
  </div>
);
}

export const TcoDropdown = (props) => {
return (
  <div className={props.parentDivClassname} id={props.parentDivId}>
  <DropdownButton title={props.dropdownTitle} id={props.dropdownId} className={props.dropdownClassname}>
  {
        props.dropdownData.map((item) => {
        return (
          <MenuItem eventKey={item.cmdtId}  className={props.menuClassname} style={ props.menuItemClass}
          onSelect={() => props.dataItemClick(item.cmdtId,item.cmdtDesc)}
          >
            {i18next.t(item.cmdtDesc)}
          </MenuItem>
        );
      })
    }
  </DropdownButton>
  </div>
);
}
